import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../Styles/Form/TableView.css";
import { v4 as uuidv4 } from "uuid";
import tableview_icon from "../../Assets/tableview_icon.svg";
import allFormIcon from "../../Assets/AllFormICon.svg";
import Starred from "../../Assets/Starred.png";
import Unstarred from "../../Assets/Unstarred.png";
import Ascending from "../../Assets/Ascending.png";
import Descending from "../../Assets/Descending.png";
import threedots from "../../Assets/threedots.svg";
import formresponsesstar from "../../Assets/formresponsesstar.png";
import ResponsesTableView from "./ResponsesTableView";
import { useDispatch } from "react-redux";
import { initializeForm } from "../../Redux/Reducer/ResponseSlices";
import Filter from "../../Assets/Filter.png";
import eye from "../../Assets/eye.png";
import chevron_down from "../../Assets/chevron-down.png";
import ellipsis_vertical from "../../Assets/ellipsis-vertical.png";
import QuestionFilterItem from "./QuestionFilterItem";
import columndndicon from "../../Assets/columndndicon.png";

export const TabularView = () => {
  const formId = useParams();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [formData, setFormData] = useState([]);
  const { formTitle, allUsersResponses } = formData;
  const dispatch = useDispatch();
  const [showRowOption, setShowRowOption] = useState(null);
  const [showResponsesTableView, setShowDropdownTableView] = useState(false);
  const [userData, setUserData] = useState([]);

  const URl = process.env.REACT_APP_API;
  const getForm = async () => {
    try {
      const response = await axios.get(
        `${URl}/forms/${formId.formId}/individual`
      );

      // setFormData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getForm();
  }, [formId.formId]);

  // Get the initial sorting options from the URL query parameters
  const getQueryParam = (param, defaultValue) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param) || defaultValue;
  };

  // Initial state from the URL query parameters or default values
  const [sortOption, setSortOption] = useState(
    getQueryParam("sortOption", "all")
  );

  // Update data and URL when sort options change
  useEffect(() => {
    // Function to fetch sorted data from the API
    const fetchSortedData = async () => {
      const Url = process.env.REACT_APP_API;
      try {
        const response = await axios.get(
          `${Url}/forms/${formId.formId}/individual?sortOption=${sortOption}`
        );
        setFormData(response.data);
      } catch (error) {
        console.error("Error fetching sorted data:", error);
      }
    };
    // Function to update the URL based on the selected options
    const updateUrl = () => {
      const newUrl = new URL(window.location);
      newUrl.searchParams.set("sortOption", sortOption);
      window.history.pushState({}, "", newUrl);
    };
    fetchSortedData();
    updateUrl();
  }, [formId.formId, sortOption]);

  const questions = allUsersResponses
    ?.flatMap((user) =>
      user.responsesAndQuestion?.flatMap((section) => section)
    )
    .reduce((acc, question) => {
      if (!acc.some((q) => q.questionId === question.questionId)) {
        acc.push({
          questionId: question.questionId,
          questionText: question.questionText.replace(/<\/?p>/g, ""), // Remove <p> tags
        });
      }
      return acc;
    }, []);

  const handleAddClick = async () => {
    navigate(`addResponse`);
  };

  const handleIconClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleSortOptionClick = (optionText) => {
    setSortOption(optionText.toLowerCase());
    setShowDropdown(false);
  };

  const dropdownOptions = [
    { text: "All", icon: allFormIcon },
    { text: "Ascending", icon: Starred },
    { text: "Descending", icon: Unstarred },
    { text: "Starred", icon: Ascending },
    { text: "Unstarred", icon: Descending },
  ];

  // Function to format the response based on its type
  const formatResponse = (response, type) => {
    console.log(response);
    if (type === "Short Answer" || type === "String" || type === "Number") {
      return response || "No response"; // Direct string response
    } else if (type === "Multiple Choice" && Array.isArray(response)) {
      return response.join(", "); // Array of strings
    } else if (type === "Check box") {
      return response.map((response) => `${response}`).join(", "); // Checkbox response
    } else if (type === "Multiple Choice grid") {
      return (
        response.map((item) => (
          <div style={{ display: "flex", gap: "3px" }}>
            <p>{item.rowText}</p>:<p>{item.value}</p>
          </div>
        )) || "No response"
      );
    } else if (type === "Name") {
      return `${response.firstName} ${response.lastName}`; //
    } else if (type === "Check box grid") {
      return response.map((item) => (
        <div style={{ display: "flex", gap: "5px" }}>
          <p>{item.rowText}</p>:
          {item.values.map((value) => (
            <p style={{ display: "flex", gap: "3px", padding: "0 2px" }}>
              {value},
            </p>
          ))}
        </div>
      )); //
    } else if (type === "Date - Time") {
      return `Date: ${response.date}, Time: ${response.time}`;
    } else if (type === "Audio/Video Upload" || type === "File Upload") {
      return response.map((item, idx) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "start",
          }}
        >
          <p>
            {idx + 1}. {item[0].fileName}
          </p>
        </div>
      ));
    } else if (type === "Location") {
      return (
        <div style={{ display: "flex", gap: "0.8rem" }}>
          {response.map((item, idx) => (
            <div
              style={{
                display: "flex",
              }}
            >
              <p>{item.value},</p>
            </div>
          ))}
        </div>
      );
    } else {
      return response || "No response"; // Fallback to JSON
    }
  };

  const onCloseResponsesTableView = () => {
    setShowDropdownTableView(false);
  };
  const rowDropDown = [
    {
      text: "View entry",
      icon: "",
    },
    {
      text: "Edit entry",
      icon: "",
    },
    {
      text: "Download",
      icon: "",
    },
    {
      text: "Star",
      icon: "",
    },
    {
      text: "Insert row above",
      icon: "",
    },
    {
      text: "Insert row below",
      icon: "",
    },
    {
      text: "Delete",
      icon: "",
    },
  ];
  const handelRowFunction = (index) => {
    setShowRowOption((prev) => (prev === index ? null : index));
  };

  const handleDownload = async (option, userId) => {
    const Url = process.env.REACT_APP_API;
    if (option === "Download") {
      try {
        const response = await axios.get(
          `${Url}/forms/getresponse/${formId.formId}/${userId.userId}`,
          { responseType: "blob" }
        );
        // Create a link to download the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "form_responses.xlsx"); // Set the filename
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        setShowRowOption(null);
      } catch (error) {
        // console.error("Error downloading the Excel file:", error);
      }
    }
    if (option === "Star") {
      try {
        const response = await axios.post(
          `${Url}/forms/star/${formId.formId}/${userId.userId}`
        );

        if (response.data.status) {
          getForm();
          setShowRowOption(null);
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (option === "Delete") {
      try {
        const response = await axios.delete(
          `${Url}/forms/deleteUserResponse/${userId.userId}`
        );
        if (response.data.status) {
          getForm();
          setShowRowOption(null);
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (option === "View entry") {
      setShowRowOption(null);
      const Url = process.env.REACT_APP_API;
      try {
        const response = await axios.get(
          `${Url}/forms/singleUserResponse/${formId.formId}?userId=${userId.userId}`
        );
        if (response.data.status === true) {
          console.log(response.data);
          setUserData(response.data.allUsersResponses[0]);
          setShowDropdownTableView(true);
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    }
    if (option === "Insert row above") {
      navigate(`addResponse/${userId.order}`);
    }
    if (option === "Insert row below") {
      navigate(`addResponse/${userId.order + 1}`);
    }
    if (option === "Edit entry") {
      try {
        const Url = process.env.REACT_APP_API;
        try {
          const response = await axios.get(
            `${Url}/forms/singleUserResponse/${formId.formId}?userId=${userId.userId}`
          );
          if (response.data.status === true) {
            const data = response.data.allUsersResponses[0];
            dispatch(
              initializeForm({
                formId: formId.formId,
                userId: data.userId,
                responses: data.responsesAndQuestion,
              })
            );
            navigate("addResponse");
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSelectChange = async (userId) => {
    const Url = process.env.REACT_APP_API;
    try {
      const response = await axios.get(
        `${Url}/forms/singleUserResponse/${formId.formId}?userId=${userId.userId}`
      );
      if (response.data.status === true) {
        setUserData(response.data.allUsersResponses[0]);
        setShowDropdownTableView(true);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  // Format the date
  const truncateText = (text, maxLength) => {
    if (text?.length <= maxLength) {
      return text;
    }
    return text?.slice(0, maxLength) + "...";
  };
  const maxLength = 20;

  // column filters
  const [isOpenColumnFilter, setColumnFilter] = useState(false);

  const handelColumnFilter = () => {
    setColumnFilter(!isOpenColumnFilter);
  };

  const [visibleColumns, setVisibleColumns] = useState([]);
  useEffect(() => {
    if (questions) {
      setVisibleColumns(questions?.map((q) => q.questionId));
    }
  }, []);

  const handleColumnToggle = (questionId) => {
    setVisibleColumns((prev) =>
      prev.includes(questionId)
        ? prev.filter((id) => id !== questionId)
        : [...prev, questionId]
    );
  };
  const [selectAll, setSelectAll] = useState(false);

  // Array of all question IDs
  const allQuestionIds = questions?.map((q) => q.questionId);

  // Handle "Hide All Columns" checkbox toggle
  const handleSelectAllToggle = () => {
    if (selectAll) {
      setVisibleColumns([]); // Clear all IDs
    } else {
      setVisibleColumns(allQuestionIds); // Add all IDs
    }
    setSelectAll(!selectAll);
  };
  return (
    <>
      <ResponsesTableView
        isOpen={showResponsesTableView}
        onClose={onCloseResponsesTableView}
        user={userData}
        allUsers={allUsersResponses}
        handleSelectChange={handleSelectChange}
      />
      <div className="formTable_view">
        <div className="inside_value">
          <div className="form-top-details">
            <p>{truncateText(formTitle, maxLength)}</p>
            <div className="filter-option-container">
              <div className="filter-container">
                <img src={Filter} alt="Filter" />
                Filter
              </div>
              <div className="columns-filter">
                <img src={eye} alt="eye" />
                Columns
                <img
                  src={chevron_down}
                  alt="chevron-down"
                  onClick={handelColumnFilter}
                />
                {isOpenColumnFilter && (
                  <div className="column-filter-container">
                    <p>helle llo world</p>
                    <div></div>
                    {/* <QuestionFilterItem
                        key={index}
                        id={question}
                        question={question}
                        checked={visibleColumns.includes(question.questionId)}
                        onChange={() => handleColumnToggle(question.questionId)}
                      /> */}
                    <div>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="option"
                          className="column-filter-input"
                          checked={selectAll}
                          onChange={handleSelectAllToggle}
                        />
                        <span className="custom-checkbox-mark"></span>
                        <p>Hide All</p>
                      </label>
                    </div>
                    {questions?.map((question, index) => (
                      <div
                        key={index}
                        style={{ display: "flex", gap: "0.51rem" }}
                      >
                        <img src={columndndicon} alt="columndndicon" />
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            name="option"
                            className="column-filter-input"
                            checked={visibleColumns.includes(
                              question.questionId
                            )}
                            onChange={() =>
                              handleColumnToggle(question.questionId)
                            }
                          />
                          <span className="custom-checkbox-mark"></span>
                          <p></p>
                          <p className="column-filter-text">
                            {question.questionText}
                          </p>
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="more-option-container">
                <img src={ellipsis_vertical} alt="ellipsis-vertical" />
              </div>
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <table className="tableview-table">
              <thead>
                <tr
                  style={{
                    backgroundColor: "black",
                    color: "white",
                  }}
                >
                  <th
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      color: "white",
                      width: "6rem",
                      minWidth: "6rem",
                      maxWidth: "4rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        position: "relative",
                      }}
                    >
                      <p>S.NO</p>
                      <img
                        src={tableview_icon}
                        alt="tableview_icon"
                        onClick={handleIconClick}
                      />
                      {/* Dropdown menu */}
                      {showDropdown && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: "0",
                            backgroundColor: "white",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "10px",
                            zIndex: 10,
                            width: "15rem",
                            borderRadius: "4px",
                            color: "#8493B2",
                          }}
                        >
                          {dropdownOptions.map((option, index) => (
                            <div
                              key={index}
                              onClick={() => handleSortOptionClick(option.text)}
                              style={{
                                display: "flex",
                                gap: "1.2rem",
                                // justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 0.5rem",
                                cursor: "pointer",
                                borderRadius: "4px",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#f0f0f0")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                            >
                              <span>
                                <img src={option.icon} alt={option.text} />
                              </span>
                              <span>{option.text}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </th>
                  {/* S.No Column */}
                  {questions
                    ?.filter((q) => visibleColumns.includes(q.questionId))
                    ?.map((question) => (
                      <th
                        key={question.questionId}
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          color: "#ffffff",
                          minWidth: "20rem",
                          maxWidth: "22rem",
                          whiteSpace: "nowrap", // Prevent text wrapping
                          overflow: "hidden", // Hide overflow text
                          textOverflow: "ellipsis", // Add ellipsis for overflowing text
                        }}
                      >
                        {truncateText(
                          question.questionText.replace(/<[^>]*>/g, ""),
                          maxLength
                        )}
                        {/* Remove HTML tags */}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {allUsersResponses?.map((user, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        padding: "0.8rem",
                        border: "1px solid #ddd",
                        color: "black",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <p>{index + 1}</p>
                        {user.star && (
                          <div>
                            <img
                              src={formresponsesstar}
                              alt="formresponsesstar"
                            />
                          </div>
                        )}
                        <img
                          src={threedots}
                          alt="threedots"
                          onClick={() => handelRowFunction(index)}
                        />
                        {showRowOption === index && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: "0",
                              backgroundColor: "white",
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                              padding: "10px",
                              zIndex: 10,
                              width: "15rem",
                              borderRadius: "4px",
                              color: "#8493B2",
                            }}
                          >
                            {rowDropDown.map((option, index) => (
                              <div
                                key={index}
                                onClick={() =>
                                  handleDownload(option.text, user)
                                }
                                style={{
                                  display: "flex",
                                  gap: "1.2rem",
                                  // justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "10px 0.5rem",
                                  cursor: "pointer",
                                  borderRadius: "4px",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.backgroundColor = "#f0f0f0")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.backgroundColor =
                                    "transparent")
                                }
                              >
                                <span>
                                  {/* <img src={option.icon} alt={option.text} /> */}
                                </span>
                                <span>{option.text}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </td>
                    {/* {questions.map((q) => {
                      const answer = user.responsesAndQuestion
                        .flatMap((section) => section)
                        .find(
                          (response) => response.questionId === q.questionId
                        ).answer;
                      return (
                        <td
                          key={q.questionId}
                          style={{
                            padding: "8px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          {truncateText(formatResponse(answer), maxLength)}
                        </td>
                      );
                    })} */}

                    {user.responsesAndQuestion
                      ?.filter((q) => visibleColumns.includes(q.questionId))
                      .map((q, colIndex) => (
                        <td
                          key={q.questionId}
                          style={{
                            padding: "8px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          {formatResponse(q.answer, q.type)}
                        </td>
                      ))}
                  </tr>
                ))}

                {/* Empty row with 'Add' button */}
                <tr>
                  <td
                    onClick={handleAddClick}
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      cursor: "pointer",
                      color: "#8493B2",
                      textAlign: "center",
                    }}
                  >
                    ADD
                  </td>
                  {questions?.map((_, index) => (
                    <td
                      key={index}
                      style={{
                        padding: "8px",
                        border: "1px solid #ddd",
                      }}
                    ></td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
